import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useUser from '../../../hooks/useUser';
import CategoryOnlineReportCEO from './CategoryOnlineReportCEO';
import CategoryOnlineReportAdmin from './CategoryOnlineReportAdmin';
import CategoryOnlineReportManager from './CategoryOnlineReportManager';
import { clearErrors } from './categoryOnlineReportSlice';

const CategoryOnlineReports = () => {
    const dispatch = useDispatch();
    const { userRole } = useUser();

    useEffect(() => {
        dispatch(clearErrors());
    }, [dispatch]);

    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';

    if (roleLower === 'ceo') {
        return <CategoryOnlineReportCEO />;
    }
    if (roleLower === 'admin') {
        return <CategoryOnlineReportAdmin />;
    }
    return <CategoryOnlineReportManager />;
};

export default CategoryOnlineReports;
